<template>
	<div id="app">
		<router-view/>
		<properties-menu/>
		<form-loading-spinner/>
	</div>
</template>

<script>

	// Import firebase services
	import { firebaseAuth } from '@/firebase/firebase-config'
	
	// Import the components
	import PropertiesMenu from '@/components/framework/nav/menus/PropertiesMenu.vue'
	import FormLoadingSpinner from '@/components/framework/helpers/FormLoadingSpinner.vue'

	export default {

	  	/*
		** Set the component name
		*/

		name: 'App',

		/*
		**  Register the components
		*/

		components: {

			PropertiesMenu,
			FormLoadingSpinner

		},

		/*
		**  Set up the data
		*/

		data: () => ({

			userID: null,

		}),

		/*
		**  Do this first
		*/

		created() {

			// Get current auth'd user
			let user = firebaseAuth.currentUser;

			// If logged in
			if(user) {

				this.userID = user.uid;

			}

		}

	}

</script>
